export const menu = [
  {
    label: '全部消息',
    key: 'ALL',
    href: '#/message/index',
  },
  {
    label: '未读消息',
    key: 'UNREAD',
    href: '#/message/unread',
  },
  {
    label: '已读消息',
    key: 'READ',
    href: '#/message/read',
  },
];
